<script setup lang="ts">
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { useI18n } from "vue-i18n";

definePage({
  meta: {
    title: "Cooperation Case Room",
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PRACTICE__PRACTICE);
    },
  },
});

const { t } = useI18n();
</script>

<template>
  <v-card
    rounded="lg"
    class="tw:!mb-5 tw:!py-4 tw:!rounded-tl-none"
  >
    <v-card-text>
      <div class="tw:!font-bold tw:text-on-surface tw:text-2xl tw:leading-10">
        {{ t("models.referral.caseRoom.pageSubtitle") }}
      </div>
    </v-card-text>
  </v-card>

  <v-card
    rounded="lg"
    class="tw:!p-0"
  >
    <v-card-text class="tw:!p-0"> </v-card-text>
  </v-card>
</template>
